import {
  addDoc,
  collection,
  doc,
  getCountFromServer,
  getDoc,
  getDocs,
  getFirestore,
  limit,
  orderBy,
  query,
  setDoc,
  startAfter,
  where,
  writeBatch
} from "firebase/firestore";
import {
  AfectacionDocumentos,
  AjusteCliente,
  Cliente,
  ClientesRecibosConverter,
  Documento,
  DocumentoConverter,
  EliminarMovimiento,
  InterfazDesafectarDocumento,
  InterfazDocumentoAfectado,
  InterfazPendienteCantidad,
  InterfazPendienteImporte,
  Moneda,
  MovimientoCC,
  ServiciosListasPrecio,
  TipoMovimiento,
  VentaConverter,
  ajusteClienteConverter,
  clienteConverter,
  movimientoCCConverter,
  prepararBusqueda
} from "@fixeduy/fixedtypes";
import {defineStore} from "pinia";
import {Ref, ref} from "vue";
import {eliminarMovimientoCuentaCorriente} from "../services/cloudFunctions/eliminarMovimientoCuentaCorriente";
import {userUserStore} from "../stores/user";
import {ajusteCliente} from "./cloudFunctions/ajusteCliente";
import {documentoDesafectar} from "./cloudFunctions/documentoDesafectar";
import {documentoAfectar} from "./cloudFunctions/documentoAfectar";
import {useTasasIVAStore} from "./tasas";
import {useClientesStore} from "./clientes";

export const useCuentasCorrientesStore = defineStore("cuentasCorrientes", () => {
  const db = getFirestore();
  const cuentasCorrientes: Ref<Cliente[]> = ref([]);
  const userStore = userUserStore();
  let last: any = null;
  let mostrar = 50;
  const cargando = ref(false);
  let procesandoGetCuentasCorrientes = false;
  // const collectionRoute = `empresas/${userStore.empresa!.id}/clientes/`;
  let timerBuscar: NodeJS.Timeout | null = null;
  const buscar = ref("");
  const listasPrecios: Ref<ServiciosListasPrecio[]> = ref([]);
  const verInactivo = ref(false);
  const verTodasLasCuentas = ref(false);
  const cargarTodas = ref(false);
  let ultimaCargaVacia = false;
  const esBuscar = ref(false);
  const cuentasCorrientesCompleto: Ref<Cliente[]> = ref([]);

  const firestoreQuery = () => {
    const collectionRoute = `empresas/${userStore.empresa!.id}/clientes/`;
    if (!verInactivo.value) {
      if (buscar.value == "") {
        if (last != null) {
          return query(
            collection(db, collectionRoute),
            where("activo", "==", true),
            orderBy("nombreComercial", "asc"),
            startAfter(last),
            limit(mostrar)
          ).withConverter(clienteConverter);
        } else {
          return query(
            collection(db, collectionRoute),
            where("activo", "==", true),
            orderBy("nombreComercial", "asc"),
            limit(mostrar)
          ).withConverter(clienteConverter);
        }
      } else {
        buscar.value = prepararBusqueda(buscar.value);
        if (last != null) {
          return query(
            collection(db, collectionRoute),
            where("activo", "==", true),
            where("query", "array-contains", buscar.value),
            orderBy("nombreComercial", "asc"),
            startAfter(last),
            limit(mostrar)
          ).withConverter(clienteConverter);
        } else {
          return query(
            collection(db, collectionRoute),
            where("activo", "==", true),
            where("query", "array-contains", buscar.value),
            orderBy("nombreComercial", "asc"),
            limit(mostrar)
          ).withConverter(clienteConverter);
        }
      }
    } else {
      if (buscar.value == "") {
        if (last != null) {
          return query(
            collection(db, collectionRoute),
            orderBy("nombreComercial", "asc"),
            startAfter(last),
            limit(mostrar)
          ).withConverter(clienteConverter);
        } else {
          return query(
            collection(db, collectionRoute),
            orderBy("nombreComercial", "asc"),
            limit(mostrar)
          ).withConverter(clienteConverter);
        }
      } else {
        if (last != null) {
          return query(
            collection(db, collectionRoute),
            where("query", "array-contains", buscar.value),
            orderBy("nombreComercial", "asc"),
            startAfter(last),
            limit(mostrar)
          ).withConverter(clienteConverter);
        } else {
          return query(
            collection(db, collectionRoute),
            where("query", "array-contains", buscar.value),
            orderBy("nombreComercial", "asc"),
            limit(mostrar)
          ).withConverter(clienteConverter);
        }
      }
    }
  };

  const init = async () => {
    ultimaCargaVacia = false;
    cargando.value = true;
    last = null;
    cuentasCorrientes.value = [];
    if (!cargarTodas.value) {
      await getCuentasCorrientesInicial();
    } else {
      mostrar = 200;
      let i = 0;
      while (ultimaCargaVacia == false) {
        await getCuentasCorrientes();
        i++;
        if (i >= 50) {
          // console.log("Corto el while");
          break;
        }
      }
      mostrar = 50;
    }
    getCuentasCorrientesReordenarReCalcular();
    cargando.value = false;
  };

  const getCuentasCorrientesReordenarReCalcular = () => {
    cuentasCorrientes.value = Object.values(
      cuentasCorrientes.value.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {} as {[key: string]: Cliente})
    );

    cuentasCorrientes.value.sort((a, b) => {
      const nombreA = a.nombreComercial.toLowerCase();
      const nombreB = b.nombreComercial.toLowerCase();

      if (nombreA < nombreB) {
        return -1;
      }
      if (nombreA > nombreB) {
        return 1;
      }
      return 0;
    });
  };

  const getMovimientosDeCuenta = async (cliente: Cliente, moneda: Moneda, fechaInicio: number, fechaFin: number) => {
    const collectionRoute = `empresas/${userStore.empresa!.id}/clientes/`;

    const movimientos: MovimientoCC[] = [];
    const route = `${collectionRoute}${cliente.id}/movimientos-cuenta-corriente`;

    const querySnapshot = await getDocs(
      query(
        collection(db, route),
        where("fecha", ">=", fechaInicio),
        where("fecha", "<=", fechaFin),
        where("idMoneda", "==", moneda.id),
        orderBy("fecha", "asc"),
        orderBy("secuencia", "asc")
      ).withConverter(movimientoCCConverter)
    );

    querySnapshot.forEach(doc => {
      movimientos.push(doc.data());
    });

    return movimientos;
  };

  const getAllMovimientosDeCuenta = async (cliente: Cliente) => {
    const collectionRoute = `empresas/${userStore.empresa!.id}/clientes/`;

    const movimientos: MovimientoCC[] = [];
    const route = `${collectionRoute}${cliente.id}/movimientos-cuenta-corriente`;

    const querySnapshot = await getDocs(
      query(collection(db, route), orderBy("fecha", "asc"), orderBy("secuencia", "asc")).withConverter(
        movimientoCCConverter
      )
    );

    querySnapshot.forEach(doc => {
      movimientos.push(doc.data());
    });

    return movimientos;
  };

  const getUltimoMovimientoDeCuenta = async (cliente: Cliente, moneda: Moneda, fechaFin: number) => {
    const collectionRoute = `empresas/${userStore.empresa!.id}/clientes/`;

    const movimientos: MovimientoCC[] = [];
    const route = `${collectionRoute}${cliente.id}/movimientos-cuenta-corriente`;

    const querySnapshot = await getDocs(
      query(
        collection(db, route),
        where("fecha", "<=", fechaFin),
        where("idMoneda", "==", moneda.id),
        orderBy("fecha", "desc"),
        orderBy("secuencia", "desc"),
        limit(1)
      ).withConverter(movimientoCCConverter)
    );

    querySnapshot.forEach(doc => movimientos.push(doc.data()));

    return movimientos;
  };

  const getCuentasCorrientesInicial = async () => {
    const collectionRoute = `empresas/${userStore.empresa!.id}/clientes/`;
    const querySnapshotPesosPositiva = await getDocs(
      query(
        collection(db, collectionRoute),
        ...(!verTodasLasCuentas.value ? [where("saldoCuentas.pesos", ">", 0.001)] : []),
        ...(!verInactivo.value ? [where("activo", "==", true)] : []),
        limit(15)
      ).withConverter(clienteConverter)
    );
    querySnapshotPesosPositiva.forEach(doc => {
      const data = doc.data();
      cuentasCorrientes.value.push(data);
      cuentasCorrientesCompleto.value.push(data);
    });

    const querySnapshotPesosNegativa = await getDocs(
      query(
        collection(db, collectionRoute),
        ...(!verTodasLasCuentas.value ? [where("saldoCuentas.pesos", "<", -0.001)] : []),
        ...(!verInactivo.value ? [where("activo", "==", true)] : []),
        limit(15)
      ).withConverter(clienteConverter)
    );
    querySnapshotPesosNegativa.forEach(doc => {
      const data = doc.data();
      cuentasCorrientes.value.push(data);
      cuentasCorrientesCompleto.value.push(data);
    });

    const querySnapshotDolaresPositiva = await getDocs(
      query(
        collection(db, collectionRoute),
        ...(!verTodasLasCuentas.value ? [where("saldoCuentas.dolares", ">", 0.001)] : []),
        ...(!verInactivo.value ? [where("activo", "==", true)] : []),
        limit(15)
      ).withConverter(clienteConverter)
    );
    querySnapshotDolaresPositiva.forEach(doc => {
      const data = doc.data();
      cuentasCorrientes.value.push(data);
      cuentasCorrientesCompleto.value.push(data);
    });

    const querySnapshotDolaresNegativa = await getDocs(
      query(
        collection(db, collectionRoute),
        ...(!verTodasLasCuentas.value ? [where("saldoCuentas.dolares", "<", -0.001)] : []),
        ...(!verInactivo.value ? [where("activo", "==", true)] : []),
        limit(15)
      ).withConverter(clienteConverter)
    );
    querySnapshotDolaresNegativa.forEach(doc => {
      const data = doc.data();
      cuentasCorrientes.value.push(data);
      cuentasCorrientesCompleto.value.push(data);
    });
  };

  const getCuentasCorrientes = async () => {
    if ((procesandoGetCuentasCorrientes || ultimaCargaVacia) && !buscar.value) return;
    procesandoGetCuentasCorrientes = true;
    const querySnapshot = await getDocs(firestoreQuery());
    if (querySnapshot.docs[querySnapshot.docs.length - 1] != null) {
      last = querySnapshot.docs[querySnapshot.docs.length - 1];
    }
    ultimaCargaVacia = querySnapshot.docs.length == 0;
    querySnapshot.forEach(doc => {
      const data = doc.data();
      if (verTodasLasCuentas.value || !data.saldoCuentas || buscar.value) {
        cuentasCorrientes.value.push(data);
      } else {
        const saldos = Object.values(data.saldoCuentas);
        if (saldos.some(saldo => saldo > 0.001 || saldo < -0.001)) {
          cuentasCorrientes.value.push(data);
        }
      }
    });

    if (!buscar.value) {
      cuentasCorrientesCompleto.value = [...cuentasCorrientes.value]; // Guardar copia completa para no volver a cargarlos todos cuando buscar.value es vacío
    }

    procesandoGetCuentasCorrientes = false;
    esBuscar.value = false;
  };

  const buscarCuentasCorrientes = async (buscarCliente: string) => {
    esBuscar.value = true;
    buscar.value = buscarCliente;
    if (timerBuscar != null) clearTimeout(timerBuscar);
    if (buscarCliente == "") {
      cuentasCorrientes.value = [...cuentasCorrientesCompleto.value];
      esBuscar.value = false;
      getCuentasCorrientesReordenarReCalcular();
      return;
    }
    timerBuscar = setTimeout(() => {
      cuentasCorrientes.value = [];
      last = null;
      getCuentasCorrientes();
    }, 500);
  };

  const ajusteAgregarDeuda = (cliente: Cliente, monto: number) => {
    // console.log(cliente);
    // console.log(monto);
  };

  const ajusteQuitarDeuda = (cliente: Cliente, monto: number) => {
    // console.log(cliente);
    // console.log(monto);
  };

  const ajustarCuentaCorriente = async (
    cliente: Cliente,
    montoAjuste: number,
    moneda: string,
    detalle: string,
    tipoAjuste: TipoMovimiento,
    nuevoSaldo: number,
    fecha: number
  ) => {
    try {
      const resultado = await ajusteCliente({
        version: 1,
        id: "",
        idEntidad: cliente.id,
        nombreEntidad: cliente.nombreComercial,
        importe: montoAjuste,
        idMoneda: moneda,
        descripcion: detalle,
        tipo: tipoAjuste,
        fecha: fecha,
        fechaString: "",
        saldo: montoAjuste
      });

      for (let i: number = 0; i < cuentasCorrientes.value.length; i++) {
        if (cuentasCorrientes.value[i].id == cliente.id) {
          cuentasCorrientes.value[i].saldoCuentas[moneda] = nuevoSaldo;
          break;
        }
      }
      return resultado;
    } catch (e) {
      throw e;
    }
  };

  const eliminarMovimiento = async (idEntidad: string, idMovimiento: string, idAjuste: string) => {
    try {
      let tipoEntidad: EliminarMovimiento["tipoEntidad"];
      tipoEntidad = "clientes";
      const resultado = await eliminarMovimientoCuentaCorriente({
        idEntidad,
        tipoEntidad,
        idMovimiento,
        idAjuste
      });
      return resultado;
    } catch (e) {
      throw e;
    }
  };

  const recalcularSaldo = async (idCliente: string, idMoneda: string) => {
    const collectionRoute = `empresas/${userStore.empresa!.id}/clientes/`;

    const movimientos: MovimientoCC[] = [];
    const route = `${collectionRoute}${idCliente}/movimientos-cuenta-corriente`;

    const batch = writeBatch(db);
    try {
      const querySnapshot = await getDocs(
        query(collection(db, route), where("idMoneda", "==", idMoneda), orderBy("fecha", "asc")).withConverter(
          movimientoCCConverter
        )
      );

      let saldoActual = 0;
      let secuenciaActual = 1;

      for (const doc of querySnapshot.docs) {
        const movimiento = doc.data();
        if (
          movimiento.tipo == TipoMovimiento.Venta ||
          movimiento.tipo == TipoMovimiento.VentaNotaDebito ||
          movimiento.tipo == TipoMovimiento.AjusteAgregarDeudaCliente ||
          movimiento.tipo == TipoMovimiento.ReciboAnulacion
        ) {
          saldoActual += movimiento.importe;
        } else {
          saldoActual -= movimiento.importe;
        }

        // Actualizamos el saldo y la secuencia del movimiento
        movimiento.saldo = saldoActual;
        movimiento.secuencia = secuenciaActual;
        movimientos.push(movimiento);

        secuenciaActual++;

        const movimientoRef = doc.ref;
        batch.update(movimientoRef, movimiento);
      }

      await batch.commit();

      const docRef = doc(db, collectionRoute, idCliente).withConverter(clienteConverter);

      const docSnapshot = await getDoc(docRef);

      if (docSnapshot.exists()) {
        // console.log(docSnapshot.data());
        const cliente = docSnapshot.data();
        if (movimientos.length > 0) {
          cliente.saldoCuentas[idMoneda] = movimientos[movimientos.length - 1].saldo;
        } else {
          cliente.saldoCuentas[idMoneda] = 0;
        }

        // Actualizamos el saldo para la moneda específica en el documento del cliente
        await setDoc(docRef, cliente, {merge: true});
        if (movimientos.length > 0) {
          return movimientos[movimientos.length - 1].saldo;
        }
        return 0;
      } else {
        return null;
      }
    } catch (e) {
      console.error("Error en la consulta: ", e);
      throw e;
    }
  };

  const deshacerAfectacionesDocumentoCancelantes = async (docData: Documento) => {
    const tasasStore = useTasasIVAStore();
    if (docData.tipoDocumento == "ventaNotaCredito") {
      const comprobanteRef = doc(db, `empresas/${userStore.empresa!.id}/ventas/`, docData.documentoId).withConverter(
        VentaConverter
      );

      const compSnapshot = await getDoc(comprobanteRef);
      if (compSnapshot.exists()) {
        const ventaNC = compSnapshot.data();
        ventaNC.saldo = ventaNC.total;

        // Actualizamos el saldo con el total
        await setDoc(comprobanteRef, ventaNC, {merge: true});

        // Armo documento
        const arrayDisponibleCantidad: InterfazPendienteCantidad[] = [];
        const arrayDisponibleImporte: InterfazPendienteImporte[] = [];

        if (ventaNC.tipoDevolucion == "devolucionCantidad" || ventaNC.tipoDevolucion == "devolucionTotal") {
          let nroLinea = 0;
          const arrayIVA: string[] = [];
          for (const detalle of ventaNC.detalleDevolucion) {
            const ventaSaldo: {ventaId: string; importe: number} = {
              ventaId: detalle.idVenta,
              importe: 0
            };

            for (const linea of detalle.lineasVenta) {
              ventaSaldo.importe += Number((linea.precio * linea.cantidadDevolver).toFixed(2));

              if (linea.importe == 0) {
                linea.precio = 0;
              }

              if (linea.cantidadDevolver > 0) {
                // Pendiente cantidad
                let tipo: "producto" | "manual" = "manual";
                let productoId = "";
                let servicioId = "";
                if (linea.stock) {
                  tipo = "producto";
                  productoId = linea.idProducto;
                } else {
                  if (linea.idServicio != "") {
                    servicioId = linea.idServicio;
                  }
                }
                const pendienteCantidad: InterfazPendienteCantidad = {
                  version: 1,
                  cantidadOriginal: linea.cantidadDevolver,
                  cantidadActual: linea.cantidadDevolver,
                  nroLinea: nroLinea,
                  tipo: tipo,
                  productoId: productoId,
                  servicioId: servicioId,
                  descripcion: linea.descripcion,
                  precioUnitario: Number(linea.precio.toFixed(6)),
                  importe: Number((linea.precio * linea.cantidadDevolver).toFixed(2)),
                  tasaIVA: linea.tasaIva,
                  rubro: linea.rubro,
                  codigo: linea.codigo
                };
                arrayDisponibleCantidad.push(pendienteCantidad);

                nroLinea++;
              }
              // Armo importe pendiente al devolver cantidades
              if (!arrayIVA.includes(linea.tasaIva)) {
                arrayIVA.push(linea.tasaIva);
              }
            }
          }
        }

        for (let comprobante of ventaNC.detalleDevolucionImporte) {
          for (let relacion of comprobante.relacionImporteTasasPendientes) {
            let pendienteImporte: InterfazPendienteImporte = {
              version: 1,
              descripcion: comprobante.descripcion,
              importe: relacion.importe,
              tasaIVA: relacion.tasaIva,
              nroLinea: relacion.nroLinea
            };
            arrayDisponibleImporte.push(pendienteImporte);
          }
        }

        let documentoAux: Documento = {
          version: 1,
          id: docData.id,
          tipoDocumento: docData.tipoDocumento,
          documentoId: docData.documentoId,
          fechaComprobante: docData.fechaComprobante,
          fechaCreacion: docData.fechaCreacion,
          fechaVencimiento: docData.fechaVencimiento,
          comprobante: docData.comprobante,
          formaDePago: docData.formaDePago,
          nroComprobante: docData.nroComprobante,
          entidadId: docData.entidadId,
          entidadNombre: docData.entidadNombre,
          moneda: docData.moneda,
          monedaCuentaAfectada: docData.monedaCuentaAfectada,
          cotizacion: docData.cotizacion,
          tipoCambioAcuentaAfectada: docData.tipoCambioAcuentaAfectada,
          cancelado: false,
          cancelo: false,
          pendienteCancelarCantidad: [],
          pendienteCancelarImporte: [],
          disponibleCancelarCantidad: arrayDisponibleCantidad,
          disponibleCancelarImporte: arrayDisponibleImporte,
          importe: docData.importe,
          importeDisponible: docData.importe,
          importePendiente: 0,
          canceladoPor: [],
          cancela: [],
          tipoCancelacionRecibida: [],
          tipoCancelacionRealizada: [],
          relacionCancelacionesRealizada: [],
          relacionCancelacionesRecibida: [],
          anulado: docData.anulado,
          redondeo: docData.redondeo
        };

        const documentoRef = doc(db, `empresas/${userStore.empresa!.id}/documentos/`, docData.id).withConverter(
          DocumentoConverter
        );
        const docSnapshot = await getDoc(documentoRef);
        if (docSnapshot.exists()) {
          // Actualizamos el saldo con el total
          await setDoc(documentoRef, documentoAux, {merge: true});
        }
      } else {
        // console.log("Entro a devolver null");
        // return null;
      }
    } else if (docData.tipoDocumento == "reciboCliente") {
      // Es recibo cliente

      const comprobanteRef = doc(
        db,
        `empresas/${userStore.empresa!.id}/recibos-clientes/`,
        docData.documentoId
      ).withConverter(ClientesRecibosConverter);

      const compSnapshot = await getDoc(comprobanteRef);
      if (compSnapshot.exists()) {
        const recibo = compSnapshot.data();
        recibo.saldo = recibo.total;

        // Actualizamos el saldo con el total
        await setDoc(comprobanteRef, recibo, {merge: true});

        // Armo documento
        const arrayDisponibleImporte: InterfazPendienteImporte[] = [];

        let pendienteImporte: InterfazPendienteImporte = {
          version: 1,
          descripcion: "No facturable",
          importe: recibo.total,
          tasaIVA: tasasStore.getTasaIVAByCFEId("NoFac")?.id!,
          nroLinea: 0
        };
        arrayDisponibleImporte.push(pendienteImporte);

        let documentoAux: Documento = {
          version: 1,
          id: docData.id,
          tipoDocumento: docData.tipoDocumento,
          documentoId: docData.documentoId,
          fechaComprobante: docData.fechaComprobante,
          fechaCreacion: docData.fechaCreacion,
          fechaVencimiento: docData.fechaVencimiento,
          comprobante: docData.comprobante,
          formaDePago: docData.formaDePago,
          nroComprobante: docData.nroComprobante,
          entidadId: docData.entidadId,
          entidadNombre: docData.entidadNombre,
          moneda: docData.moneda,
          monedaCuentaAfectada: docData.monedaCuentaAfectada,
          cotizacion: docData.cotizacion,
          tipoCambioAcuentaAfectada: docData.tipoCambioAcuentaAfectada,
          cancelado: false,
          cancelo: false,
          pendienteCancelarCantidad: [],
          pendienteCancelarImporte: [],
          disponibleCancelarCantidad: [],
          disponibleCancelarImporte: arrayDisponibleImporte,
          importe: docData.importe,
          importeDisponible: docData.importe,
          importePendiente: 0,
          canceladoPor: [],
          cancela: [],
          tipoCancelacionRecibida: [],
          tipoCancelacionRealizada: [],
          relacionCancelacionesRealizada: [],
          relacionCancelacionesRecibida: [],
          anulado: docData.anulado,
          redondeo: docData.redondeo
        };
        const documentoRef = doc(db, `empresas/${userStore.empresa!.id}/documentos/`, docData.id).withConverter(
          DocumentoConverter
        );
        const docSnapshot = await getDoc(documentoRef);
        if (docSnapshot.exists()) {
          // Actualizamos el saldo con el total
          await setDoc(documentoRef, documentoAux, {merge: true});
        }
      }
    } else if (docData.tipoDocumento == "ajustequitardeudacliente") {
      // Es ajuste quitar deuda cliente
      const comprobanteRef = doc(
        db,
        `empresas/${userStore.empresa!.id}/ajustes-clientes/`,
        docData.documentoId
      ).withConverter(ajusteClienteConverter);

      const compSnapshot = await getDoc(comprobanteRef);
      if (compSnapshot.exists()) {
        const ajuste = compSnapshot.data();

        ajuste.saldo = ajuste.importe;

        // Actualizamos el saldo con el total
        await setDoc(comprobanteRef, ajuste, {merge: true});

        // Armo documento
        const arrayDisponibleImporte: InterfazPendienteImporte[] = [];

        let pendienteImporte: InterfazPendienteImporte = {
          version: 1,
          descripcion: ajuste.descripcion,
          importe: ajuste.importe,
          tasaIVA: tasasStore.getTasaIVAByCFEId("NoFac")?.id!,
          nroLinea: 0
        };
        arrayDisponibleImporte.push(pendienteImporte);

        let documentoAux: Documento = {
          version: 1,
          id: docData.id,
          tipoDocumento: docData.tipoDocumento,
          documentoId: docData.documentoId,
          fechaComprobante: docData.fechaComprobante,
          fechaCreacion: docData.fechaCreacion,
          fechaVencimiento: docData.fechaVencimiento,
          comprobante: docData.comprobante,
          formaDePago: docData.formaDePago,
          nroComprobante: docData.nroComprobante,
          entidadId: docData.entidadId,
          entidadNombre: docData.entidadNombre,
          moneda: docData.moneda,
          monedaCuentaAfectada: docData.monedaCuentaAfectada,
          cotizacion: docData.cotizacion,
          tipoCambioAcuentaAfectada: docData.tipoCambioAcuentaAfectada,
          cancelado: false,
          cancelo: false,
          pendienteCancelarCantidad: [],
          pendienteCancelarImporte: [],
          disponibleCancelarCantidad: [],
          disponibleCancelarImporte: arrayDisponibleImporte,
          importe: docData.importe,
          importeDisponible: docData.importe,
          importePendiente: 0,
          canceladoPor: [],
          cancela: [],
          tipoCancelacionRecibida: [],
          tipoCancelacionRealizada: [],
          relacionCancelacionesRealizada: [],
          relacionCancelacionesRecibida: [],
          anulado: docData.anulado,
          redondeo: docData.redondeo
        };
        const documentoRef = doc(db, `empresas/${userStore.empresa!.id}/documentos/`, docData.id).withConverter(
          DocumentoConverter
        );
        const docSnapshot = await getDoc(documentoRef);
        if (docSnapshot.exists()) {
          // Actualizamos el saldo con el total
          await setDoc(documentoRef, documentoAux, {merge: true});
        }
      }
    }
  };

  const deshacerAfectacionesDocumentoCancelados = async (docData: Documento) => {
    const tasasStore = useTasasIVAStore();

    if (docData.tipoDocumento == "venta") {
      // Es una venta
      const comprobanteRef = doc(db, `empresas/${userStore.empresa!.id}/ventas/`, docData.documentoId).withConverter(
        VentaConverter
      );

      const compSnapshot = await getDoc(comprobanteRef);

      if (compSnapshot.exists()) {
        const venta = compSnapshot.data();
        venta.saldo = venta.total;

        // Actualizamos el saldo con el total
        await setDoc(comprobanteRef, venta, {merge: true});

        // Armo documento
        const arrayPendienteCantidad: InterfazPendienteCantidad[] = [];
        const arrayPendienteImporte: InterfazPendienteImporte[] = [];

        const arrayIVA: string[] = [];

        let nroLinea = 0;
        for (const linea of venta.ventaLinea) {
          if (linea.descripcion == "Redondeo") {
            continue;
          }

          // Sumo iva en caso de que montoBruto = 0
          let precioConIVA = linea.precio - linea.descuentoMonto / linea.cantidad;
          let importeConIVA = linea.importe;
          if (linea.montoBruto == 0) {
            const tasa = tasasStore.getTasaIVAById(linea.tasaIva);
            // const tasa = tasasIva.find(tasa => tasa.id === linea.tasaIva);
            if (tasa) {
              precioConIVA =
                linea.precio * (1 + tasa.valor / 100) -
                (linea.descuentoMonto / linea.cantidad) * (1 + tasa.valor / 100);
              importeConIVA = linea.importe * (1 + tasa.valor / 100);
            }
          }

          // Pendiente cantidad
          let tipo: "producto" | "servicio" | "manual" = "manual";
          let productoId = "";
          let servicioId = "";
          if (linea.tipo == "producto") {
            tipo = "producto";
            productoId = linea.idProducto;
          } else {
            if (linea.idServicio != "") {
              tipo = "servicio";
              servicioId = linea.idServicio;
            }
          }

          const pendienteCantidad: InterfazPendienteCantidad = {
            version: 1,
            cantidadOriginal: linea.cantidad,
            cantidadActual: linea.cantidad,
            nroLinea: nroLinea,
            tipo: tipo,
            productoId: productoId,
            servicioId: servicioId,
            descripcion: linea.descripcion,
            precioUnitario: Number(precioConIVA.toFixed(6)), // con descuento
            importe: Number(importeConIVA.toFixed(2)), // con descuento
            tasaIVA: linea.tasaIva,
            rubro: linea.rubro,
            codigo: linea.codigo
          };
          arrayPendienteCantidad.push(pendienteCantidad);
          nroLinea++;

          // Pendiente importe
          // Armo array de tasas iva, falta calcular totales por tasas
          if (!arrayIVA.includes(linea.tasaIva)) {
            arrayIVA.push(linea.tasaIva);
          }
        }

        // Armo importe pendiente  por cada tasa
        nroLinea = 0;
        for (const iva of arrayIVA) {
          let importe = 0;
          for (const linea of venta.ventaLinea) {
            if (linea.descripcion == "Redondeo") {
              continue;
            }

            let precioConIVA = linea.precio - linea.descuentoMonto / linea.cantidad;
            // Sumo el iva en caso de que montoBruto = 0
            if (linea.montoBruto == 0) {
              // const tasa = tasasIva.find(tasa => tasa.id === linea.tasaIva);
              const tasa = tasasStore.getTasaIVAById(linea.tasaIva);
              if (tasa) {
                precioConIVA =
                  linea.precio * (1 + tasa.valor / 100) -
                  (linea.descuentoMonto / linea.cantidad) * (1 + tasa.valor / 100);
              }
            }

            if (iva == linea.tasaIva) {
              importe += linea.cantidad * precioConIVA;
            }
          }
          const tasa = tasasStore.getTasaIVAById(iva); //tasasIva.find(tasa => tasa.id === iva);
          if (tasa && importe != 0) {
            const pendienteImporte: InterfazPendienteImporte = {
              version: 1,
              descripcion: tasa.nombre,
              importe: Number(importe.toFixed(2)), // Con iva
              tasaIVA: iva,
              nroLinea: nroLinea
            };
            nroLinea++;
            arrayPendienteImporte.push(pendienteImporte);
          }
        }

        const documentoAux: Documento = {
          version: 1,
          id: docData.id,
          tipoDocumento: "venta",
          documentoId: venta.id,
          fechaComprobante: docData.fechaComprobante,
          fechaCreacion: docData.fechaCreacion,
          fechaVencimiento: docData.fechaVencimiento,
          comprobante: venta.comprobante,
          formaDePago: docData.formaDePago,
          nroComprobante: docData.nroComprobante,
          entidadId: docData.entidadId,
          entidadNombre: docData.entidadNombre,
          moneda: docData.moneda,
          monedaCuentaAfectada: docData.moneda,
          cotizacion: docData.cotizacion,
          tipoCambioAcuentaAfectada: docData.tipoCambioAcuentaAfectada,
          cancelado: false,
          cancelo: false,
          pendienteCancelarCantidad: arrayPendienteCantidad,
          disponibleCancelarCantidad: arrayPendienteCantidad,
          pendienteCancelarImporte: arrayPendienteImporte,
          disponibleCancelarImporte: arrayPendienteImporte,
          importe: docData.importe, // con iva
          importePendiente: docData.importe,
          importeDisponible: docData.importe,
          canceladoPor: [],
          cancela: [],
          tipoCancelacionRecibida: [],
          tipoCancelacionRealizada: [],
          relacionCancelacionesRealizada: [],
          relacionCancelacionesRecibida: [],
          anulado: docData.anulado,
          redondeo: docData.redondeo
        };
        const documentoRef = doc(db, `empresas/${userStore.empresa!.id}/documentos/`, docData.id).withConverter(
          DocumentoConverter
        );
        const docSnapshot = await getDoc(documentoRef);
        if (docSnapshot.exists()) {
          // Actualizamos el saldo con el total
          await setDoc(documentoRef, documentoAux, {merge: true});
        }
      }
    } else if (docData.tipoDocumento == "ventaNotaDebito") {
      // Es una Nota de debito
      const comprobanteRef = doc(db, `empresas/${userStore.empresa!.id}/ventas/`, docData.documentoId).withConverter(
        VentaConverter
      );

      const compSnapshot = await getDoc(comprobanteRef);

      if (compSnapshot.exists()) {
        const venta = compSnapshot.data();
        venta.saldo = venta.total;

        // Actualizamos el saldo con el total
        await setDoc(comprobanteRef, venta, {merge: true});

        // Armo documento
        const arrayPendienteCantidad: InterfazPendienteCantidad[] = [];
        const arrayPendienteImporte: InterfazPendienteImporte[] = [];

        const arrayIVA: string[] = [];

        let nroLinea = 0;
        for (const linea of venta.ventaLinea) {
          if (linea.descripcion == "Redondeo") {
            continue;
          }

          // Sumo iva en caso de que montoBruto = 0
          let precioConIVA = linea.precio - linea.descuentoMonto / linea.cantidad;
          let importeConIVA = linea.importe;
          if (linea.montoBruto == 0) {
            const tasa = tasasStore.getTasaIVAById(linea.tasaIva);
            // const tasa = tasasIva.find(tasa => tasa.id === linea.tasaIva);
            if (tasa) {
              precioConIVA =
                linea.precio * (1 + tasa.valor / 100) -
                (linea.descuentoMonto / linea.cantidad) * (1 + tasa.valor / 100);
              importeConIVA = linea.importe * (1 + tasa.valor / 100);
            }
          }

          // Pendiente cantidad
          let tipo: "producto" | "servicio" | "manual" = "manual";
          let productoId = "";
          let servicioId = "";
          if (linea.tipo == "producto") {
            tipo = "producto";
            productoId = linea.idProducto;
          } else {
            if (linea.idServicio != "") {
              tipo = "servicio";
              servicioId = linea.idServicio;
            }
          }

          const pendienteCantidad: InterfazPendienteCantidad = {
            version: 1,
            cantidadOriginal: linea.cantidad,
            cantidadActual: linea.cantidad,
            nroLinea: nroLinea,
            tipo: tipo,
            productoId: productoId,
            servicioId: servicioId,
            descripcion: linea.descripcion,
            precioUnitario: Number(precioConIVA.toFixed(6)), // con descuento
            importe: Number(importeConIVA.toFixed(2)), // con descuento
            tasaIVA: linea.tasaIva,
            rubro: linea.rubro,
            codigo: linea.codigo
          };
          arrayPendienteCantidad.push(pendienteCantidad);
          nroLinea++;

          // Pendiente importe
          // Armo array de tasas iva, falta calcular totales por tasas
          if (!arrayIVA.includes(linea.tasaIva)) {
            arrayIVA.push(linea.tasaIva);
          }
        }

        // Armo importe pendiente  por cada tasa
        nroLinea = 0;
        for (const iva of arrayIVA) {
          let importe = 0;
          for (const linea of venta.ventaLinea) {
            if (linea.descripcion == "Redondeo") {
              continue;
            }

            let precioConIVA = linea.precio - linea.descuentoMonto / linea.cantidad;
            // Sumo el iva en caso de que montoBruto = 0
            if (linea.montoBruto == 0) {
              // const tasa = tasasIva.find(tasa => tasa.id === linea.tasaIva);
              const tasa = tasasStore.getTasaIVAById(linea.tasaIva);
              if (tasa) {
                precioConIVA =
                  linea.precio * (1 + tasa.valor / 100) -
                  (linea.descuentoMonto / linea.cantidad) * (1 + tasa.valor / 100);
              }
            }

            if (iva == linea.tasaIva) {
              importe += linea.cantidad * precioConIVA;
            }
          }
          const tasa = tasasStore.getTasaIVAById(iva); //tasasIva.find(tasa => tasa.id === iva);
          if (tasa && importe != 0) {
            const pendienteImporte: InterfazPendienteImporte = {
              version: 1,
              descripcion: tasa.nombre,
              importe: Number(importe.toFixed(2)), // Con iva
              tasaIVA: iva,
              nroLinea: nroLinea
            };
            nroLinea++;
            arrayPendienteImporte.push(pendienteImporte);
          }
        }

        const documentoAux: Documento = {
          version: 1,
          id: docData.id,
          tipoDocumento: "ventaNotaDebito",
          documentoId: venta.id,
          fechaComprobante: docData.fechaComprobante,
          fechaCreacion: docData.fechaCreacion,
          fechaVencimiento: docData.fechaVencimiento,
          comprobante: venta.comprobante,
          formaDePago: docData.formaDePago,
          nroComprobante: docData.nroComprobante,
          entidadId: docData.entidadId,
          entidadNombre: docData.entidadNombre,
          moneda: docData.moneda,
          monedaCuentaAfectada: docData.moneda,
          cotizacion: docData.cotizacion,
          tipoCambioAcuentaAfectada: docData.tipoCambioAcuentaAfectada,
          cancelado: false,
          cancelo: false,
          pendienteCancelarCantidad: arrayPendienteCantidad,
          disponibleCancelarCantidad: [],
          pendienteCancelarImporte: arrayPendienteImporte,
          disponibleCancelarImporte: [],
          importe: docData.importe, // con iva
          importePendiente: docData.importe,
          importeDisponible: 0,
          canceladoPor: [],
          cancela: [],
          tipoCancelacionRecibida: [],
          tipoCancelacionRealizada: [],
          relacionCancelacionesRealizada: [],
          relacionCancelacionesRecibida: [],
          anulado: docData.anulado,
          redondeo: docData.redondeo
        };
        const documentoRef = doc(db, `empresas/${userStore.empresa!.id}/documentos/`, docData.id).withConverter(
          DocumentoConverter
        );
        const docSnapshot = await getDoc(documentoRef);
        if (docSnapshot.exists()) {
          // Actualizamos el saldo con el total
          await setDoc(documentoRef, documentoAux, {merge: true});
        }
      }
    } else if (docData.tipoDocumento == "ajusteagregardeudacliente") {
      // Es ajuste agregar deuda cliente

      const comprobanteRef = doc(
        db,
        `empresas/${userStore.empresa!.id}/ajustes-clientes/`,
        docData.documentoId
      ).withConverter(ajusteClienteConverter);

      const compSnapshot = await getDoc(comprobanteRef);
      if (compSnapshot.exists()) {
        const ajuste = compSnapshot.data();

        ajuste.saldo = ajuste.importe;

        // Actualizamos el saldo con el total
        await setDoc(comprobanteRef, ajuste, {merge: true});

        // Armo documento

        const arrayDisponibleImporte: InterfazPendienteImporte[] = [];

        let pendienteImporte: InterfazPendienteImporte = {
          version: 1,
          descripcion: ajuste.descripcion,
          importe: ajuste.importe,
          tasaIVA: tasasStore.getTasaIVAByCFEId("NoFac")?.id!,
          nroLinea: 0
        };
        arrayDisponibleImporte.push(pendienteImporte);

        let documentoAux: Documento = {
          version: 1,
          id: docData.id,
          tipoDocumento: docData.tipoDocumento,
          documentoId: docData.documentoId,
          fechaComprobante: docData.fechaComprobante,
          fechaCreacion: docData.fechaCreacion,
          fechaVencimiento: docData.fechaVencimiento,
          comprobante: docData.comprobante,
          formaDePago: docData.formaDePago,
          nroComprobante: docData.nroComprobante,
          entidadId: docData.entidadId,
          entidadNombre: docData.entidadNombre,
          moneda: docData.moneda,
          monedaCuentaAfectada: docData.monedaCuentaAfectada,
          cotizacion: docData.cotizacion,
          tipoCambioAcuentaAfectada: docData.tipoCambioAcuentaAfectada,
          cancelado: false,
          cancelo: false,
          pendienteCancelarCantidad: [],
          pendienteCancelarImporte: arrayDisponibleImporte,
          disponibleCancelarCantidad: [],
          disponibleCancelarImporte: [],
          importe: docData.importe,
          importeDisponible: 0,
          importePendiente: docData.importe,
          canceladoPor: [],
          cancela: [],
          tipoCancelacionRecibida: [],
          tipoCancelacionRealizada: [],
          relacionCancelacionesRealizada: [],
          relacionCancelacionesRecibida: [],
          anulado: docData.anulado,
          redondeo: docData.redondeo
        };
        const documentoRef = doc(db, `empresas/${userStore.empresa!.id}/documentos/`, docData.id).withConverter(
          DocumentoConverter
        );
        const docSnapshot = await getDoc(documentoRef);
        if (docSnapshot.exists()) {
          // Actualizamos el saldo con el total
          await setDoc(documentoRef, documentoAux, {merge: true});
        }
      }
    }
  };

  const deshacerAfectaciones = async (idCliente: string, idMoneda: string) => {
    const route = `empresas/${userStore.empresa!.id}/documentos/`;
    try {
      let tiposDocumentosCancelantes: string[] = ["ventaNotaCredito", "reciboCliente", "ajustequitardeudacliente"];
      let tiposDocumentosCancelados: string[] = ["venta", "ventaNotaDebito", "ajusteagregardeudacliente"];

      // Desafecto documentos afectantes
      const querySnapshotDesafectar = await getDocs(
        query(
          collection(db, route),
          where("entidadId", "==", idCliente),
          where("monedaCuentaAfectada", "==", idMoneda),
          // where("anulado", "==", false),
          where("tipoDocumento", "in", tiposDocumentosCancelantes),
          where("formaDePago", "==", "credito"),
          orderBy("fechaComprobante", "asc")
        ).withConverter(DocumentoConverter)
      );
      const promisesDesafectar: Promise<void>[] = [];
      for (const document of querySnapshotDesafectar.docs) {
        let docData = document.data();
        // console.log("Entro en cancelantes con ", docData.comprobante);
        promisesDesafectar.push(deshacerAfectacionesDocumentoCancelantes(docData));
      }
      await Promise.all(promisesDesafectar);
      // console.log(` finalizo la desafectacion de los cancelantes  ${promisesDesafectar.length}`);

      const querySnapshotAfectar = await getDocs(
        query(
          collection(db, route),
          where("entidadId", "==", idCliente),
          where("moneda", "==", idMoneda),
          // where("anulado", "==", false),
          where("tipoDocumento", "in", tiposDocumentosCancelados),
          where("formaDePago", "==", "credito"),
          orderBy("fechaComprobante", "asc")
        ).withConverter(DocumentoConverter)
      );
      const promisesDesafectarCancelados: Promise<void>[] = [];
      for (const document of querySnapshotAfectar.docs) {
        let docData = document.data();
        // console.log("Entro en cancelados con ", docData.comprobante);
        promisesDesafectarCancelados.push(deshacerAfectacionesDocumentoCancelados(docData));
      }
      await Promise.all(promisesDesafectarCancelados);
      // console.log(` finalizo la desafectacion de los cancelados ${promisesDesafectarCancelados.length}`);

      return true;
    } catch (e) {
      console.error("Error en la consulta: ", e);
      throw e;
    }
  };

  const realizarAfectaciones = async (idCliente: string, idMoneda: string) => {
    const route = `empresas/${userStore.empresa!.id}/documentos/`;
    const tasasStore = useTasasIVAStore();
    try {
      let tiposDocumentosCancelantes: string[] = ["ventaNotaCredito", "reciboCliente", "ajustequitardeudacliente"];
      let tiposDocumentosCancelados: string[] = ["venta", "ventaNotaDebito", "ajusteagregardeudacliente"];

      // Ahora a afectar FIFO
      let finalizado = false;

      while (!finalizado) {
        // setTimeout(() => {
        //   // document.body.removeChild(iframe);
        // }, 2000);
        const querySnapshotReafectar = await getDocs(
          query(
            collection(db, route),
            where("entidadId", "==", idCliente),
            where("monedaCuentaAfectada", "==", idMoneda),
            where("anulado", "==", false),
            where("tipoDocumento", "in", tiposDocumentosCancelantes),
            where("formaDePago", "==", "credito"),
            where("importeDisponible", ">", 0)
            // orderBy("fechaComprobante", "asc")
            // limit(1)
          ).withConverter(DocumentoConverter)
        );

        let cancelantes = querySnapshotReafectar.docs.map(doc => doc.data());
        // cancelantes.sort((a, b) => a.fechaComprobante - b.fechaComprobante);
        cancelantes.sort((a, b) => {
          if (a.fechaComprobante === b.fechaComprobante) {
            // Si fechaComprobante es igual, ordenar por fechaCreacion
            return a.fechaCreacion - b.fechaCreacion;
          }
          // Ordenar por fechaComprobante
          return a.fechaComprobante - b.fechaComprobante;
        });
        if (!cancelantes || cancelantes.length == 0) {
          finalizado = true;
        }

        let cancelanteActual = cancelantes[0];

        let i = 0;
        if (cancelanteActual) {
          // console.log("Afecto documento ", cancelanteActual.comprobante);
          const afectaciones: AfectacionDocumentos = {
            idDocumento: cancelanteActual.id,
            documentos: []
          };
          if (cancelanteActual.moneda != cancelanteActual.monedaCuentaAfectada) {
            if (cancelanteActual.tipoCambioAcuentaAfectada) {
              cancelanteActual.importeDisponible =
                cancelanteActual.importeDisponible * cancelanteActual.tipoCambioAcuentaAfectada;
            }
          }
          while (cancelanteActual.importeDisponible > 0) {
            // Obtengo todos los comprobantes a cancelar ordenados por fecha comprobante
            const querySnapshotAfectados = await getDocs(
              query(
                collection(db, route),
                where("entidadId", "==", idCliente),
                where("moneda", "==", idMoneda),
                where("anulado", "==", false),
                where("tipoDocumento", "in", tiposDocumentosCancelados),
                where("formaDePago", "==", "credito"),
                where("importePendiente", ">", 0)
                // orderBy("fechaComprobante", "asc")
              ).withConverter(DocumentoConverter)
            );

            const cancelados = querySnapshotAfectados.docs.map(doc => doc.data());
            cancelados.sort((a, b) => a.fechaComprobante - b.fechaComprobante);
            if (!cancelados || cancelados.length == 0) {
              finalizado = true;
            }

            let canceladoActual = cancelados[i];
            if (!canceladoActual) {
              break;
            }

            let importe = 0;
            let saldo = 0;

            if (cancelanteActual.importeDisponible <= canceladoActual.importePendiente) {
              importe = cancelanteActual.importeDisponible;
              saldo = canceladoActual.importePendiente - cancelanteActual.importeDisponible;
              cancelanteActual.importeDisponible = 0;
            } else {
              importe = canceladoActual.importePendiente;
              cancelanteActual.importeDisponible -= canceladoActual.importePendiente;

              saldo = 0;
            }

            const afectacion: InterfazDocumentoAfectado = {
              version: 1,
              idComprobante: canceladoActual.documentoId,
              idDocumento: canceladoActual.id,
              descripcion: "Documento " + canceladoActual.comprobante,
              tipoDocumento: canceladoActual.tipoDocumento,
              importe: importe,
              saldoOriginal: canceladoActual.importe,
              saldo: saldo,
              nroLinea: 0
            };

            afectaciones.documentos.push(afectacion);

            i++;
          }
          if (afectaciones.documentos.length > 0) {
            await documentoAfectar(afectaciones);
          }
        } else {
          // finalizado = true;
          break;
        }
      }
      return true;
    } catch (e) {
      console.error("Error en la consulta: ", e);
      throw e;
    }
  };

  const rehacerAfectaciones = async (idCliente: string, idMoneda: string) => {
    try {
      await deshacerAfectaciones(idCliente, idMoneda);
      await realizarAfectaciones(idCliente, idMoneda);
      return true;
    } catch (e) {
      console.error("Error en la consulta: ", e);
      return false;
    }
  };

  const transferirMovimientos = async (movimiento: MovimientoCC, cliente: Cliente) => {
    const collectionRoute = `empresas/${userStore.empresa!.id}/clientes/`;

    try {
      const movimientos = await getAllMovimientosDeCuenta(cliente);
      const existeMovimiento = movimientos.some(
        mov => mov.idDocumento === movimiento.idDocumento && mov.tipo === movimiento.tipo
      );
      if (!existeMovimiento) {
        const docRef = doc(
          collection(db, `${collectionRoute}${cliente.id}/movimientos-cuenta-corriente`)
        ).withConverter(movimientoCCConverter);
        movimiento.id = docRef.id;
        await setDoc(docRef, movimiento);
        return true;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const editarAjuste = async (ajuste: AjusteCliente) => {
    const docRef = doc(db, `empresas/${userStore.empresa!.id}/ajustes-clientes/`, ajuste.id).withConverter(
      ajusteClienteConverter
    );
    await setDoc(
      docRef,
      {
        ...ajuste
      },
      {merge: true}
    );
  };

  const transferirAjustes = async (clienteOriginalId: string, clienteNuevoId: string) => {
    const documentosRef = collection(
      getFirestore(),
      `empresas/${userStore.empresa!.id}/ajustes-clientes/`
    ).withConverter(ajusteClienteConverter);
    const q = query(documentosRef, where("idEntidad", "==", clienteOriginalId));
    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      for (const doc of querySnapshot.docs) {
        let ajuste = doc.data();
        ajuste = {...ajuste, idEntidad: clienteNuevoId};
        editarAjuste(ajuste);
      }
    }
  };

  const getCantidadAjustesCliente = async (id: string) => {
    try {
      const q = query(
        collection(db, `empresas/${userStore.empresa!.id}/ajustes-clientes/`).withConverter(ajusteClienteConverter),
        where("idEntidad", "==", id),
        limit(1)
      );

      const snapshot = await getCountFromServer(q);
      return snapshot.data().count;
    } catch (e) {
      console.error("Error en la consulta: ", e);
      throw e;
    }
  };

  const vaciarCuentasCorrientes = () => {
    cuentasCorrientes.value = [];
    ultimaCargaVacia = false;
    last = null;
    cargarTodas.value = false;
  };

  const getClientesAfectar = async () => {
    const collectionRoute = `empresas/${userStore.empresa!.id}/clientes/`;

    const clientes: Cliente[] = [];
    const querySnapshot = await getDocs(
      query(collection(db, collectionRoute), where("activo", "==", true)).withConverter(clienteConverter)
    );

    querySnapshot.forEach(doc => {
      const data = doc.data();
      // const tieneSaldo = Object.values(data.saldoCuentas).some(saldo => saldo != 0);
      // if (tieneSaldo) {
      clientes.push(data);
      // }
    });

    return clientes;
  };

  const getClientesAfectarAmedatolPendientesNegativos = async () => {
    const collectionRoute = `empresas/${userStore.empresa!.id}/documentos/`;
    const clienteStore = useClientesStore();

    const clientes: Cliente[] = [];
    const documentos: Documento[] = [];
    const querySnapshot = await getDocs(
      query(
        collection(db, collectionRoute),
        where("anulado", "==", false),
        where("formaDePago", "==", "credito"),
        where("importePendiente", "<", -1)
      ).withConverter(DocumentoConverter)
    );

    querySnapshot.forEach(doc => {
      const data = doc.data();
      let existeEntidad = documentos.find(doc => doc.entidadId == data.entidadId);
      if (!existeEntidad) {
        documentos.push(data);
      }
    });
    console.log("Documentos ", documentos);

    for (const doc of documentos) {
      const cliente = await clienteStore.geClienteById(doc.entidadId);
      if (cliente) {
        clientes.push(cliente);
      }
    }

    return clientes;
  };

  return {
    init,
    cuentasCorrientes,
    cargando,
    cargarTodas,
    ajusteAgregarDeuda,
    ajusteQuitarDeuda,
    getCuentasCorrientes,
    buscarCuentasCorrientes,
    listasPrecios,
    verInactivo,
    buscar,
    getMovimientosDeCuenta,
    getAllMovimientosDeCuenta,
    transferirMovimientos,
    transferirAjustes,
    getCantidadAjustesCliente,
    getUltimoMovimientoDeCuenta,
    ajustarCuentaCorriente,
    eliminarMovimiento,
    verTodasLasCuentas,
    recalcularSaldo,
    deshacerAfectaciones,
    rehacerAfectaciones,
    realizarAfectaciones,
    vaciarCuentasCorrientes,
    getClientesAfectar,
    getClientesAfectarAmedatolPendientesNegativos
  };
});
